const LANGUAGES = {
  EN: 'en',
  UA: 'ua',
};

const SOCIALS = {
  FACEBOOK: 'https://www.facebook.com/Warriors.Of.Light.Code',
  INSTAGRAM: 'https://instagram.com/warriors_of_light_code',
  LANDING: 'https://www.armedconflict.law/',
  TIKTOK: 'https://www.tiktok.com/@warriors_of_light_code',
  YOUTUBE: 'https://www.youtube.com/@Warriors_Of_Light',
};

const COOKIES_POLICY_URL =
  'https://geneva-learning-platform-resources.s3.eu-north-1.amazonaws.com/cookie-consent.html';

const SUPPORT_EMAIL = 'support.team@armedconflict.law';
const MOD_LINK = 'https://app.armedconflict.law/';
export { COOKIES_POLICY_URL, LANGUAGES, MOD_LINK, SOCIALS, SUPPORT_EMAIL };
